// Third-party Library
import React, { useState } from "react";
import { Modal, Upload, Button, Typography, message } from "antd";
import { InboxOutlined, DeleteOutlined, CloseOutlined, CheckCircleOutlined } from "@ant-design/icons";

// Handlers
import { uploadHDLR } from "../../../../../handlers";

// Services Library
import { TIME } from "../../../../../services/util";

// Styles
import styles from './index.module.css'

const { Dragger } = Upload;
const { Text } = Typography;

const {
    parseTime
} = TIME

const { getBase64, handleBeforeUpload, UploadReceiptImage, DeleteImage } = uploadHDLR;

const ModalReceipt = ({ open, onCancel, onSave, receiptData }) => {

    const [ previewUrl, setPreviewUrl ] = useState(receiptData.attachment || null);
    const [ success, setSuccess ] = useState(false)

    const {
        plate = '-',
        startTime = '-',
        fuel = "-",
        cost = "-",
        location = {},
    } = receiptData || {};

    const handleRemove = () => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        DeleteImage(previewUrl)
        setPreviewUrl(null);
    };

    const handleSave = () => {
        if (!previewUrl) {
            message.warning("Please upload your image.");
            return;
        }
        onSave(previewUrl)
        handleReset();
        setSuccess(true)
    };

    const handleCancel = () => {
        handleReset();
        onCancel?.();
        setSuccess(false)
    };

    const handleReset = () => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        // setFile(null);
        setPreviewUrl(null);
    };

    const handleChangeAttachment = (info) => {
        const { status, originFileObj, response = {} } = info.file;

        if(status === "done") {
            getBase64(originFileObj, () => {
                const { url } = response;

                setPreviewUrl(url?.replace('#', '%23'))

            });
        }
    };

    return (
        <Modal
            title={<h3>Upload Receipt</h3>}
            open={open}
            onCancel={handleCancel}
            width={580}
            closeIcon={<CloseOutlined />}
            footer={
                success
                &&
                <Button type="primary" onClick={handleCancel}>Close</Button>
                ||
                <div className={styles["container-btn"]}>
                    <Button onClick={handleCancel}>Cancel</Button>
                    <Button type="primary" onClick={handleSave}>Save Receipt</Button>
                </div>
            }
        >
            {
                success
                &&
                <SuccessReceipt setSuccess={setSuccess} />
                ||
                <div className={styles["container"]}>
                    <div style={{ flex: 1 }}>
                        <InfoRow label="Vehicle" value={plate} />
                        <InfoRow label="Event Time" value={parseTime(startTime)} />
                        <InfoRow label="Fuel (L)" value={fuel} />
                        <InfoRow label="Cost (MYR)" value={cost} />
                        <InfoRow label="Location" value={`${location.lat}, ${location.lon}`} isLast />
                    </div>

                    <div style={{ flex: 1 }}>
                        {
                            previewUrl ? (
                                <div className={styles["container-preview-img"]}>
                                    <img
                                        src={previewUrl}
                                        alt="Receipt preview"
                                        className={styles["preview-img"]}
                                    />
                                    <Button
                                        size="small"
                                        danger
                                        icon={<DeleteOutlined />}
                                        onClick={handleRemove}
                                        className={styles["container-btn-delete-img"]}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            ) : (
                                <Dragger
                                    multiple={false}
                                    accept=".jpg,.jpeg,.png"
                                    beforeUpload={handleBeforeUpload}
                                    customRequest={(e) => {
                                        return UploadReceiptImage(`images/vehicle/fuel/receipt/${receiptData.vid}`, e, receiptData.startTime)}
                                    }
                                    onChange={handleChangeAttachment}
                                    showUploadList={false}
                                >
                                    <p className="ant-upload-drag-icon"><InboxOutlined style={{ color: "#1677ff", fontSize: 32 }} /></p>
                                    <p className="ant-upload-text" style={{ fontSize: 14 }}>Drag &amp; drop receipt photo<br />or click to upload.</p>
                                    <p className="ant-upload-hint" style={{ fontSize: 12 }}>JPG, PNG up to 5MB</p>
                                </Dragger>
                            )
                        }
                    </div>
                </div>
            }
        </Modal>
    );
};

// Helper sub-component for each info row
const InfoRow = ({ label, value }) => (
    <div style={{ paddingBottom: 8 }}>
        <Text type="secondary" style={{ fontSize: 12 }}>{label}</Text>
        <br />
        <Text style={{ fontSize: 14 }}>{value}</Text>
    </div>
);

const SuccessReceipt = ({ setSuccess }) => (
    <div style={{ textAlign: 'center' }}>
        <CheckCircleOutlined style={{ color: 'green', fontSize: '5em' }} />
        <h3 style={{ margin: '1em 0' }}>Receipt uploaded successfully!</h3>
        <Button style={{ color: 'blue', borderColor: 'blue' }} onClick={() => setSuccess(false)}>View Receipt</Button>
    </div>
)

export default React.memo(ModalReceipt)